<script>
import wfList from "@/data/wf.json";

export default {
  name: "wf-selector",
  props: {
    value: {
      type: Object,
      default: {}
    },
    specialityCode: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      wf: { code: undefined, name: undefined }
    };
  },
  computed: {
    sortedWfList() {
      return [...(this.wf?.code ? [[null, "Любое"]] : []), ...this.wfList.sort((a, b) => a[0].localeCompare(b[0]))];
    },
    wfList() {
      return this.specialityCode ? wfList[this.specialityCode] || [] : [];
    },
    displayText() {
      return (this.wf && this.wf.code) ? `${this.wf.code}. ${this.wf.name}` : "Выберите ТФ";
    }
  },
  methods: {
    setWF() {
      this.wf.code = this.value.code || null;
      this.wf.name = this.value.name || null;

      if (this.wf.code && !this.wf.name) {
        const found = this.wfList.find(wf => this.wf.code === wf[0]);
        if (found) {
          this.wf.name = found[1];
        }
      }
    }
  },
  mounted() {
    this.setWF(this.value);
  },
  watch: {
    // Поддержка внешнего обновления v-model
    value: {
      handler() {
        this.setWF();
      },
      deep: true
    },
    // Эмитим изменения обратно в родителя
    wf: {
      handler(newVal) {
        this.$emit("input", newVal);
      },
      deep: true
    }
  }
};
</script>

<template>
  <b-dropdown
    :text="displayText"
    boundary="viewport"
    menu-class="dropdown-menu-custom"
    no-caret
    size="sm"
    variant="outline-dark"
  >
    <b-dropdown-item
      v-for="item in sortedWfList"
      :key="item[0]"
      class="dropdown-item-custom"
      @click="wf = { code: item[0], name: item[1] }"
    >
      {{ `${item[0] ?? ""} ${item[1]}` }}
    </b-dropdown-item>
  </b-dropdown>
</template>


<style scoped>
/* Добавьте стили при необходимости */
</style>
